import { baseTheme } from '@streamlain/theme';
import { css, unsafeCSS } from 'lit';

export const PeekViewStyles = css`
  :host {
    display: block;
    width: 100%;
    height: auto;
    font-family: ${unsafeCSS(baseTheme.fontSansFamily)};
  }

  .ai-chat-block-peek-view-container {
    width: 100%;
    max-height: min(70vh, 680px);
    box-sizing: border-box;
  }

  ai-chat-composer {
    width: 100%;
  }
`;
